/* wn-calm.js (LUXE): the rainbow blur->clear FX was removed; only functional helpers remain. */
/* video reviews: load + play only tiles on screen */
(function () {
  var vids = document.querySelectorAll('[data-vr-src]');
  if (!vids.length) return;
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (!v.src) v.src = v.getAttribute('data-vr-src'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!v.paused) v.pause();
    });
  }, { rootMargin: '0px 120px' });
  vids.forEach(function (v) { io.observe(v); });
})();
/* collection hero lifestyle slideshow */
(function () {
  var root = document.querySelector('[data-cl-slides]'); if (!root) return;
  var slides = root.querySelectorAll('.cl-slide'); if (slides.length < 2) return;
  var wear = document.querySelector('[data-cl-wear]'), dots = document.querySelectorAll('.cl-dots i');
  var i = 0, reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  slides.forEach(function (s, k) { if (k) { var im = s.querySelector('img'); im && (im.loading = 'eager'); } });
  function go(n) {
    slides[i].classList.remove('is-on'); dots[i] && dots[i].classList.remove('is-on');
    i = n % slides.length;
    slides[i].classList.add('is-on'); dots[i] && dots[i].classList.add('is-on');
    if (wear) { wear.href = slides[i].dataset.url; wear.querySelector('b').textContent = slides[i].dataset.product; }
  }
  if (!reduce) setInterval(function () { if (!document.hidden) go(i + 1); }, 5000);
})();
/* cart 3-for-2 dropdown: keep open state across drawer re-renders */
(function () {
  var open = false;
  document.addEventListener('toggle', function (e) { if (e.target.matches && e.target.matches('[data-wc-b2x]')) open = e.target.open; }, true);
  document.addEventListener('wn:cart:updated', function () { var d = document.querySelector('[data-wc-b2x]'); if (d && open) d.open = true; });
})();
/* animate close of the cart best-sellers shelf */
document.addEventListener('click', function (e) {
  var s = e.target.closest && e.target.closest('[data-wc-b2x] > summary'); if (!s) return;
  var d = s.parentElement; if (!d.open) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  e.preventDefault(); d.classList.add('is-closing');
  setTimeout(function () { d.classList.remove('is-closing'); d.open = false; }, 190);
}, true);
